/**
 * Splits text into pieces about the size of a model's tokens: a word with its leading space, with longer words broken into chunks of
 * four characters, which is near enough the usual rule of thumb of four characters a token.
 *
 * @param text - The text to split.
 * @returns The pieces, in order, which join back into `text`.
 */
export function toTokens(text: string): string[] {
  const pieces: string[] = [];
  for (const chunk of text.match(/\s*\S+/g) ?? []) {
    const space = /^\s*/.exec(chunk)?.[0] ?? "";
    const word = chunk.slice(space.length);
    for (let start = 0; start < word.length; start += 4) {
      pieces.push((start === 0 ? space : "") + word.slice(start, start + 4));
    }
  }
  return pieces;
}
